import { connect } from 'react-redux';
import SiteListing from './siteListing';
import { bindActionCreators } from 'redux';
import {
  getTaskListing,
  getSiteFilters,
  getLocationChange,
} from 'services/redux/installation/siteListing/action';

const mapStateToProps = (state) => ({
  siteListData: state.siteListingReducer.taskListData,
  siteFilters: state.siteListingReducer.siteFiltersData,
  locationChange: state.siteListingReducer.locationChange,
  userProfile : state.loginReducer.userProfile.attVal,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getTaskListing,
      getSiteFilters,
      getLocationChange,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SiteListing);
